import React, { useEffect, useState } from "react";
import Header from "./Header";
import Sidebar from "./Sidebar";
import SubHeader from "./SubHeader";
import { BASE_URL } from "../Apis/apiConfig";
import axios from "axios";
import { Trash2 } from "lucide-react";

const MemberInterestCharges = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [ratings, setRatings] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const [selectedUnit, setSelectedUnit] = useState("");

  const toggleSidebar = () => setIsSidebarOpen((prev) => !prev);

  useEffect(() => {
    fetchRatings();
  }, []);

  const fetchRatings = async () => {
    try {
      const token = localStorage.getItem("token");
      const societyName = localStorage.getItem("society");

      const res = await axios.post(
        `${BASE_URL}/member-interest-charges/get-all-member-interest-charges`,
        null,
        {
          params: { societyName },
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      setRatings(Array.isArray(res.data) ? res.data : []);
    } catch (err) {
      console.error("Error fetching ratings:", err);
      setRatings([]);
    }
  };

  const handleDelete = async (id) => {
    try {
      const token = localStorage.getItem("token");

      await axios.delete(
        `${BASE_URL}/member-interest-charges/delete-member-interest-charges`,
        {
          params: {
            memberInterestChargesId: id,
          },
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      // remove from UI
      setRatings((prev) =>
        prev.filter((item) => item.memberInterestChargesId !== id)
      );
    } catch (error) {
      console.error("Delete error:", error);
    }
  };

  const unitNumbers = [...new Set(ratings.map((item) => item.unitNo))];

  const filteredRatings = selectedUnit
    ? ratings.filter((item) => item.unitNo === selectedUnit)
    : ratings;

  const totalPages = Math.max(
    1,
    Math.ceil(filteredRatings.length / itemsPerPage)
  );

  const safePage = Math.min(currentPage, totalPages);

  const indexOfLast = safePage * itemsPerPage;
  const indexOfFirst = indexOfLast - itemsPerPage;

  const currentItems = filteredRatings.slice(indexOfFirst, indexOfLast);

  const changePage = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  return (
    <div className="app-container">
      <Header toggleSidebar={toggleSidebar} />

      <div className="main-layout">
        <Sidebar isOpen={isSidebarOpen} onClose={() => setIsSidebarOpen(false)} />

        <main className="content-area">
          <SubHeader />

          <div className="p-4">
            <div className="overflow-x-auto bg-white shadow rounded-lg">

              {/* FILTER */}
              <div className="mb-3">
                <label className="mr-2 font-medium">Filter By Unit:</label>

                <select
                  value={selectedUnit}
                  onChange={(e) => {
                    setSelectedUnit(e.target.value);
                    setCurrentPage(1);
                  }}
                  className="border p-2 rounded"
                >
                  <option value="">All Units</option>
                  {unitNumbers.map((unit) => (
                    <option key={unit} value={unit}>
                      {unit}
                    </option>
                  ))}
                </select>
              </div>

              {/* TABLE */}
              <table className="w-full border-collapse">
                <thead className="bg-gray-100 text-left text-sm font-semibold">
                  <tr>
                    <th className="p-3 border">#</th>
                    <th className="p-3 border">Unit No</th>
                    <th className="p-3 border">Member Name</th>
                    <th className="p-3 border">Interest Amount</th>
                    <th className="p-3 border">Created Date</th>
                    <th className="p-3 border">Action</th>
                  </tr>
                </thead>

                <tbody>
                  {currentItems.length > 0 ? (
                    currentItems.map((item, index) => (
                      <tr
                        key={item.memberInterestChargesId || index}
                        className="hover:bg-gray-50 transition"
                      >
                        <td className="p-3 border">
                          {indexOfFirst + index + 1}
                        </td>

                        <td className="p-3 border">{item.unitNo}</td>
                        <td className="p-3 border">{item.memberName}</td>
                        <td className="p-3 border">{item.interestAmount}</td>

                        <td className="p-3 border">
                          {new Date(item.createdDate).toLocaleString("en-GB", {
                            day: "2-digit",
                            month: "2-digit",
                            year: "numeric",
                            hour: "2-digit",
                            minute: "2-digit",
                            hour12: true,
                          })}
                        </td>

                        {/* ✅ FIXED: icon inside TD */}
                        <td className="p-3 border text-center">
                          <Trash2
                            size={18}
                            style={{ cursor: "pointer", color: "red" }}
                            onClick={() =>
                              handleDelete(item.memberInterestChargesId)
                            }
                          />
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="6" className="text-center p-4 text-gray-500">
                        No Data Found
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>

            {/* PAGINATION */}
            <div className="flex justify-center items-center gap-3 mt-4">
              <button
                onClick={() => changePage(currentPage - 1)}
                disabled={currentPage === 1}
                className="px-3 py-1 border rounded disabled:opacity-50"
              >
                Prev
              </button>

              <span className="text-sm">
                Page {safePage} of {totalPages}
              </span>

              <button
                onClick={() => changePage(currentPage + 1)}
                disabled={currentPage === totalPages}
                className="px-3 py-1 border rounded disabled:opacity-50"
              >
                Next
              </button>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
};

export default MemberInterestCharges;